import { FormField, Select } from '@/shared/components';
import { ROLES, ROLE_LABELS_DE, type Role } from '@/shared/auth';
import { PropertyPicker } from '@/features/team/PropertyPicker';

export const SELECTABLE_ACCESS_ROLES: Role[] = [
  ROLES.WorkspaceAdmin,
  ROLES.Staff,
  ROLES.Housekeeping,
  ROLES.HousekeepingManager,
  ROLES.Owner,
];

export const SCOPED_ACCESS_ROLES: Role[] = [
  ROLES.Housekeeping,
  ROLES.HousekeepingManager,
  ROLES.Owner,
];

type Company = { id: string; name: string };
type Property = { id: string; name: string };

export function UserAccessScopeEditor({
  role,
  onRoleChange,
  scoped,
  companyId,
  onCompanyChange,
  companies,
  properties,
  propertyIds,
  onPropertyToggle,
  loading,
}: {
  role: Role;
  onRoleChange: (role: Role) => void;
  scoped: boolean;
  companyId: string;
  onCompanyChange: (companyId: string) => void;
  companies: Company[];
  properties: Property[];
  propertyIds: string[];
  onPropertyToggle: (propertyId: string) => void;
  loading: boolean;
}) {
  return (
    <>
      <FormField label="Rolle" required>
        <Select value={role} onChange={(event) => onRoleChange(event.target.value as Role)}>
          {SELECTABLE_ACCESS_ROLES.map((candidate) => (
            <option key={candidate} value={candidate}>
              {ROLE_LABELS_DE[candidate]}
            </option>
          ))}
        </Select>
      </FormField>
      {scoped ? (
        <div className="border-line/50 space-y-4 rounded-md border border-dashed p-4">
          <FormField label="Firma" hint="Ihre Apartmentfreigaben werden zusätzlich wirksam.">
            <Select value={companyId} onChange={(event) => onCompanyChange(event.target.value)}>
              <option value="">— keine —</option>
              {companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.name}
                </option>
              ))}
            </Select>
          </FormField>
          <FormField label="Apartments direkt freigeben">
            <PropertyPicker
              properties={properties}
              selectedIds={propertyIds}
              onToggle={onPropertyToggle}
              disabledIds={loading ? properties.map((property) => property.id) : []}
            />
          </FormField>
        </div>
      ) : (
        <p className="border-sage/30 bg-sage/10 text-ink rounded-md border px-3 py-3 text-sm">
          Diese Rolle sieht den gesamten Workspace; Firmen- und Direktfreigaben werden nicht
          gespeichert.
        </p>
      )}
    </>
  );
}
